<template>
  <div class="tbc-record">
    <div class="head">
      <el-radio-group
        class="select-tab"
        v-model="selectedTab"
        @change="toUrl"
      >
        <el-radio-button label="索赔登记"></el-radio-button>
        <el-radio-button label="待确认表单"></el-radio-button>
        <el-radio-button label="已确认表单"></el-radio-button>
      </el-radio-group>
    </div>
    <div class="container">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        hide-required-asterisk
      >
        <div class="top">
          <div class="orther-search">
            <div class="orther-search-title">其他信息项：</div>
            <div class="orther-search-main">
              <div class="orther-search-row">
                <el-form-item label="仓库：" prop="name">
                  <el-select
                    class="gray white"
                    v-model="ruleForm.warehouseId"
                    placeholder="请选择仓库"
                  >
                    <el-option
                      v-for="item in warehouse"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="时间：" prop="billDate">
                  <el-date-picker
                    class="w190"
                    v-model="ruleForm.billDate"
                    type="date"
                    placeholder="请选择日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="快递公司：" prop="expressId">
                  <el-select
                    class="gray white"
                    v-model="ruleForm.expressId"
                    placeholder="请选择仓库"
                  >
                    <el-option
                      v-for="item in expressCompanyList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="orther-search-row">
                <el-form-item
                  label="客户名称："
                  prop="customerId"
                >
                  <el-select
                    class="gray white"
                    v-model="ruleForm.customerId"
                    placeholder="请选择客户"
                    filterable
                    @focus="focusCustomerList"
                    @change="changeCustomerList"
                  >
                    <el-option
                      v-for="item in customerList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="项目名称："
                  prop="projectId"
                >
                  <el-select
                    class="gray white"
                    v-model="ruleForm.projectId"
                    placeholder="请选择项目"
                  >
                    <el-option
                      v-for="item in projectNameList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="foot tbc-foot">
                  <el-button
                    type="primary"
                    class="btn-blue"
                    @click="search"
                    >搜索</el-button
                  >
                  <el-button class="btn-white" @click="cancel('ruleForm')">清空</el-button>
                  <el-upload
                    element-loading-text="文件导入中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    class="upload tbc-upload"
                    ref="upload"
                    action="#"
                    :show-file-list="false"
                    :auto-upload="true"
                    :before-upload="uploadClaimRegisterExcel"
                  >
                    <el-button slot="trigger" class="btn-white">导入</el-button>
                  </el-upload>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <div class="main">
          <div class="table">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column
                v-for="(item, index) in tableTitleList"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :show-overflow-tooltip="item.showToolTip"
                :min-width="item.width"
              ></el-table-column>
              <el-table-column
                label="照片"
                width="90"
              >
                <template slot-scope="scope">
                  <div class="upload-img">
                    <el-button
                      class="btn-text"
                      type="text"
                      @click="lookImg(scope.row.images)"
                    >查看</el-button>
                    <el-upload
                      element-loading-text="文件上传中"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      class="upload"
                      ref="upload"
                      action="#"
                      :show-file-list="false"
                      :auto-upload="true"
                      :class="uploadImages.length < 3 ?'':'none'"
                      :limit="3"
                      multiple
                      :on-exceed="handleLimit"
                      :before-upload="uploadClaimImg"
                    >
                      <el-button slot="trigger" type="text" class="btn-text" @click="upload(scope.row.id)">上传</el-button>
                    </el-upload>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="120"
              >
                <template slot-scope="scope">
                  <el-button
                    v-if="!scope.row.isCancel"
                    class="btn-text"
                    type="text"
                    @click="nullify(scope.row.id)"
                  >作废</el-button>
                  <el-button
                    v-if="!scope.row.isCancel&&!scope.row.isConfirmed"
                    class="btn-text"
                    type="text"
                    @click="confirm(scope.row)"
                  >确认</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <pagination-tpl
                :total="total"
                :currentPage="currentPage"
                :pageSize="pageSize"
                @queryChange="queryChange"
              ></pagination-tpl>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <!-- 查看图片 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="522px"
      class="look-img"
      >
      <el-carousel arrow="always" indicator-position="none" :autoplay="false">
        <el-carousel-item v-for="(item, index) in images" :key="index">
          <img v-if="!isNothingImg" class="img" :src="item">
          <div v-else class="nothing-container">
            <img class="nothimg-img" :src="item">
          </div>
          <div class="indicator">
            <span class="indicator-high">
              {{ index+1 }}
            </span>/
            <span>
              {{ images.length }}
            </span>
          </div>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
    <!-- 确认 -->
    <el-dialog title="确认操作" top="20vh" :visible.sync="confirmDialog" width="420px">
      <div class="border"></div>
      <el-form
        ref="confirmForm"
        :model="confirmForm"
        label-width="100px"
      >
        <el-form-item label="是否认责：" prop="isResponsible">
          <el-select
            class="white"
            v-model="confirmForm.isResponsible"
            placeholder="请选择是否认责"
          >
            <el-option
              v-for="item in isResponsibleList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="认责方：" prop="responsibleParty">
          <el-select
            class="white"
            v-model="confirmForm.responsibleParty"
            placeholder="请选择认责方"
            @change="changeResponsibleParty"
          >
            <el-option
              v-for="item in responsiblePartyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题分类：" prop="logisticsProblemsType">
          <el-select
            class="gray white"
            v-model="confirmForm.problemsType"
            placeholder="请选择问题分类"
          >
            <el-option
              v-for="item in problemTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应付金额：" prop="payableAmount">
          <el-input v-model="confirmForm.payableAmount" class="white" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item v-if="confirmForm.responsibleParty == 2" label="物流承担金额：" prop="carrierBearAmount">
          <el-input v-model="confirmForm.carrierBearAmount" class="white" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="approvalRemarks" class="remarks">
          <el-input type="textarea" v-model="confirmForm.approvalRemarks" resize="none" class="white" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="addConfirmForm('confirmForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Claim from "models/claim";
import ChargeRegister from "models/charge-register";
import Expenses from "models/expenses";
const expenses = new Expenses();
import Logistics from "models/logistics";
const logistics = new Logistics();
import PaginationTpl from "components/base/PaginationTpl";
import ImgUploader from "common/js/img-upload.js";
const imgUploader = new ImgUploader();
const DEAL_METHOD = {
  1: '补发',
  2: '退差价',
  3: '退款',
}
const RESPONSIBLE_PARTY = {
  1: '仓库',
  2: '物流',
  3: '无'
}
export default {
  components: {
    PaginationTpl
  },

  data() {
    return {
      claimId: null,
      selectedTab: "待确认表单",
      dialogVisible: false,
      warehouse: [],
      expressCompanyList: [],
      customerList: [],
      projectNameList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      images: [],
      isNothingImg: false,
      logisticsProblemTypeList: [],
      problemTypeList: [],
      tableTitleList: [
        {label: '仓库', prop: 'warehouseName', width: '', showToolTip: false},
        {label: '时间', prop: 'billDate', width: '120', showToolTip: false},
        {label: '快递公司', prop: 'expressName', width: '120', showToolTip: false},
        {label: '操作人', prop: 'operator', width: '120', showToolTip: false},
        {label: '认责方', prop: 'responsiblePartyVal', width: '120', showToolTip: false},
        {label: '问题分类', prop: 'logisticsProblemsTypeVal', width: '180', showToolTip: false},
        {label: '处理方案', prop: 'dealMethodVal', width: '120', showToolTip: false},
        {label: '订单号', prop: 'orderCode', width: '220', showToolTip: false},
        {label: '快递单号', prop: 'expressCode', width: '220', showToolTip: false},
        {label: '产品名称', prop: 'productName', width: '120', showToolTip: true},
        {label: '数量', prop: 'quantity', width: '100', showToolTip: false},
        {label: '涉及金额', prop: 'involvedAmount', width: '120', showToolTip: false},
        {label: '客户名称', prop: 'customerName', width: '120', showToolTip: false},
        {label: '项目名称', prop: 'projectName', width: '120', showToolTip: true},
      ],
      ruleForm: {
        warehouseId: '',
        billDate: '',
        expressId: '',
        customerId: '',
        projectId: '',
      },
      confirmDialog: false,
      isResponsibleList: [
        {id:1, name: '是'},
        {id:0, name: '否'},
      ],
      responsiblePartyList: [
        {id:1, name: '仓库'},
        {id:2, name: '物流'},
        {id:3, name: '无'}
      ],
      confirmForm: {
        isResponsible: '',
        responsibleParty: '',
        problemsType: '',
        payableAmount: '',
        carrierBearAmount: '',
        approvalRemarks: '',
        claimId: ''
      },
      loading: false,
      loading2: false,
      fileList: [],
      uploadImages: []
    }
  },

  async created() {
    this.getWarehouse()
    this.getLogisticsList()
    await this.initProblemTypeList(1, true)
    this.initTBCRecord()
  },

  methods: {
    toUrl(v) {
      if (v === "待确认表单") {
        this.$router.push({
          path: "/service/claim-index/tbc-record",
        });
      } else if(v === "已确认表单") {
        this.$router.push({
          path: "/service/claim-index/confirmed-record",
        });
      } else {
        this.$router.push({
          path: "/service/claim-index/claim-register",
        });
      }
    },
    /* 
      获取问题分类 
      type: true获取所有问题分类数据 false获取当前认责方的问题分类数据
    */
    async initProblemTypeList(responsibleType, type) {
      let res = await Claim.postProblemTypeList(responsibleType)
      if (res.success) {
        let arr = []
        res.result.map(i => {
          let obj = {}
          obj.id = i.id
          obj.name = i.text
          arr.push(obj)
        })
        if (type) {
          if (responsibleType == 1) {
            await this.initProblemTypeList(2, true)
          }
          this.logisticsProblemTypeList = this.logisticsProblemTypeList.concat(arr);
        } else {
          this.problemTypeList = arr
        }
      } else {
        this.$message.error(res.message)
      }
    },
    initTBCRecord() {
      let data = {
        warehouseId: this.ruleForm.warehouseId,
        billDate: this.ruleForm.billDate,
        expressId: this.ruleForm.expressId,
        customerId: this.ruleForm.customerId,
        projectId: this.ruleForm.projectId,
        currentPage: this.currentPage
      }
      Claim.getTBCRecordList(data).then(res => {
        console.log(this.logisticsProblemTypeList);
        if (res.success) {
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          let arr = []
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.warehouseId = i.warehouseId
            obj.warehouseName = i.warehouseName
            obj.billDate = i.billDate
            obj.expressId = i.expressId
            obj.expressName = i.expressName
            obj.operator = i.operator
            obj.logisticsProblemsType = i.logisticsProblemsType
            this.logisticsProblemTypeList.map(v => {
              if (i.logisticsProblemsType == v.id) {
                obj.logisticsProblemsTypeVal = v.name
              }
            })
            obj.responsibleParty = i.responsibleParty
            obj.responsiblePartyVal = RESPONSIBLE_PARTY[i.responsibleParty]
            obj.dealMethod = i.dealMethod
            obj.dealMethodVal = DEAL_METHOD[i.dealMethod]
            obj.orderCode = i.orderCode
            obj.expressCode = i.expressCode
            obj.productName = i.productName
            obj.quantity = i.quantity
            obj.involvedAmount = i.involvedAmount
            obj.customerName = i.customerName
            obj.projectName = i.projectName
            obj.images = i.imageList
            obj.isCancel = i.isCancel
            obj.isConfirmed = i.isConfirmed
            obj.isResponsible = i.isResponsible
            obj.responsibleParty = i.responsibleParty
            obj.payableAmount = i.payableAmount
            obj.carrierBearAmount = i.carrierBearAmount
            obj.approvalRemarks = i.approvalRemarks
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /* 获取仓库数据 */
    getWarehouse() {
      expenses.getWarehouseData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouse = arr;
        }
      });
    },
    focusCustomerList() {
      this.getCustomerList()
    },
    changeCustomerList() {
      this.initGetProjectList()
    },
    //获取快递公司列表
    getLogisticsList() {
      logistics.getExpressData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.expressCompanyList = arr;
        }
      });
    },
    /* 获取客户名称 */
    getCustomerList() {
      logistics.getCustomerData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.ordersName;
            arr.push(obj);
          });
          this.customerList = arr;
        }
      });
    },
    /* 获取项目名称 */
    initGetProjectList() {
      let customerId = this.ruleForm.customerId
      let warehouseId = this.ruleForm.warehouseId
      ChargeRegister.getProjectList(customerId, warehouseId).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.projectsName;
            arr.push(obj);
          });
          this.projectNameList = arr;
          this.ruleForm.projectId = arr[0].id;
        }
      });
    },
    cancel(formName) {
      this.$refs[formName].resetFields();
    },
    search() {
      this.currentPage = 1;
      this.initTBCRecord()
    },
    // 选择认责方
    changeResponsibleParty() {
      let responsibleType = 0
      if (this.confirmForm.responsibleParty != 3) {
        responsibleType = this.confirmForm.responsibleParty
      }
      this.initProblemTypeList(responsibleType, false)
    },
    //翻页
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initTBCRecord();
    },
    lookImg(v) {
      this.dialogVisible = true
      if (v.length > 0) {
        this.images = v
        this.isNothingImg = false
      } else {
        let img = require('../../../../assets/images/nothing-img.png')
        this.images = [img]
        this.isNothingImg = true
      }
    },
    confirm(row) {
      let responsibleType = 0
      if (row.responsibleParty != 3) {
        responsibleType = row.responsibleParty
      }
      this.initProblemTypeList(responsibleType, false)
      this.confirmForm.claimId = row.id
      this.confirmForm.isResponsible = row.isResponsible
      this.confirmForm.responsibleParty = row.responsibleParty
      this.confirmForm.payableAmount = row.payableAmount
      this.confirmForm.carrierBearAmount = row.carrierBearAmount
      this.confirmForm.approvalRemarks = row.approvalRemarks
      this.confirmForm.problemsType = row.logisticsProblemsType
      this.confirmDialog = true
    },
    /* 作废 */
    nullify(id) {
      let data = {
        claimId: id
      }
      Claim.postNullifyClaimList(data).then(res => {
        if (res.success) {
          this.$message.success('作废成功')
          this.initTBCRecord()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    closeDialog() {
      this.confirmDialog = false
    },
    addConfirmForm() {
      let data = {
        claimId: this.confirmForm.claimId,
        isResponsible: this.confirmForm.isResponsible,
        responsibleParty: this.confirmForm.responsibleParty,
        payableAmount: this.confirmForm.payableAmount,
        carrierBearAmount: this.confirmForm.carrierBearAmount,
        approvalRemarks: this.confirmForm.approvalRemarks,
        logisticsProblemsType: this.confirmForm.problemsType
      }
      Claim.postConfirmTBCRecord(data).then(res => {
        if (res.success) {
          this.closeDialog()
          this.initTBCRecord()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 导入
    uploadClaimRegisterExcel(file) {
      var formData = new FormData();
      formData.append("file", file);
      this.loading2 = true;
      Claim
        .postUploadClaimRegisterExcel(formData)
        .then(res => {
          if (res.success) {
            this.$message.success("导入成功");
            this.loading2 = false;
            this.initTBCRecord()
          } else {
            this.loading2 = false;
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning"
            }).then(() => {});
          }
        })
        .catch(() => {
          this.$message.error("导入失败");
          this.loading2 = false;
        });
      return false;
    },
    // 图片数量大于3
    handleLimit() {
      this.$message({
        message: "图片数量最多3张",
        type: "warning",
      });
    },
    // 上传
    uploadClaimImg(file) {
      this.fileList = []
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "image/jpg";
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt1M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
        return false;
      } else {
        this.loading = true;
        this.file = file;
        imgUploader
          .postImgUpload(this.file)
          .then((res) => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              this.fileList.push(obj);
              this.loading = false;
              this.uploadImages = [];
              this.fileList.map(value => {
                this.uploadImages.push(value.url);
              });
              this.uploadSuccess()
            } else {
              this.loading = false;
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.loading = false;
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
      }
    },
    uploadSuccess() {
      let data = {
        images: this.uploadImages,
        claimId: this.claimId
      }
      Claim.postUploadClaimImg(data).then(res => {
        if (res.success) {
          this.initTBCRecord()
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    upload(id) {
      this.claimId = id
    }
  }
}
</script>

<style lang='scss'>
.tbc-record {
  flex: 1;
  .head {
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 400;
    background: #f2f4f8;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .container {
    .top {
      box-sizing: border-box;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      padding: 32px 37px 25px 37px;
      background: #fff;
      margin-bottom: 20px;
      border-radius: 8px;
      background: #fff;
      .orther-search {
        display: flex;
        justify-content: flex-start;
        .orther-search-title {
          font-size: 14px;
          line-height: 32px;
          text-align: left;
          width: 90px;
        }
        .orther-search-main {
          .orther-search-row {
            display: flex;
          }
        }
      }
    }
    .main {
      background: #fff;
      padding: 20px;
      .table {
        min-height: 500px;
        border-radius: 4px;
      }
      .pagination {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  .w190 {
    width: 190px;
  }
  .upload-img {
    display: flex;
    justify-content: space-between;
  }
  .tbc-upload {
    margin: 0px 10px;
  }
}
</style>
<style lang="scss">
.tbc-record {
  .el-dialog {
    .el-form {
      .el-form-item__content {
        height: 32px;
        display: flex;
        align-items: center;
        .el-radio {
          margin-right: 10px;
          .el-radio__label {
            padding-left: 5px;
          }
        }
      }
      .remarks {
        .el-form-item__content {
          height: 54px;
        }
      }
    }
    .el-select {
      width: 100%;
    }
    .dialog-footer {
      margin-top: 16px;
      border-top: 1px solid #f7f7f7;
      padding-top: 16px;
      display: flex;
      justify-content: center;
    }
  }
  .look-img {
    .el-dialog__headerbtn {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      margin: 0;
      width: 522px;
      height: 522px;
      box-sizing: border-box;
      .el-carousel {
        width: 100%;
        height: 100%;
        .el-carousel__container {
          height: 100%;
          .img,
          .nothing-container {
            width: 100%;
            height: 478px;
          }
          .nothing-container {
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .nothimg-img {
            width: 320px;
            height: 250px;
          }
          .indicator {
            width: 100%;
            height: 44px;
            color: #999;
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            .indicator-high {
              color: #333;
            }
          }
        }
      }
    }
  }
  
  .tbc-foot {
    .el-form-item__content {
      margin-left: 29px !important;
      display: flex;
      justify-content: flex-start;
    }
  }
}
</style>
